import { useQueryState } from 'nuqs'
import { useFeatureFlag } from '~/context/featureFlag'

export function useContentfulPreviewMode() {
  const [previewParam] = useQueryState('preview')
  const contentfulPreviewModeEnabled = useFeatureFlag('contentful-preview-mode')
  return contentfulPreviewModeEnabled && previewParam === 'true'
}
